import { appServiceClient } from '@/infrastructure/http/httpClient';

import { IPortalAcesso, IPortalResult } from '../interfaces/portal';

class PortalRepository {
  /** Whether the person signed in is a brand buyer, and of which brands. */
  async getAcesso(): Promise<IPortalAcesso> {
    return appServiceClient.get<IPortalAcesso>('portal/acesso');
  }

  async listMarcas(): Promise<Array<string>> {
    return appServiceClient.get<Array<string>>('portal/marcas');
  }

  async getPortal(marca: string): Promise<IPortalResult> {
    return appServiceClient.get<IPortalResult>(`portal/${encodeURIComponent(marca)}`);
  }
}

export const portalRepository = new PortalRepository();
